export default "__VITE_ASSET__CN8_vH3z__"